import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import GenerateWordPage from './pages/GenerateWordPage';
import EditorPage from './pages/editor/EditorPage';
import SurveyEditorPage from './pages/survey/SurveyEditorPage';
import Navigation from './components/Navigation';
import { DocumentProvider } from './context/DocumentContext';

function App() {
  return (
    <DocumentProvider>
      <Router>
        <div className="App">
          <header className="App-header">
            <Navigation />
            <div className="content-container">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/gendocx" element={<GenerateWordPage />} />
                <Route path="/editor" element={<EditorPage />} />
                <Route path="/survey-editor" element={<SurveyEditorPage />} />
              </Routes>
            </div>
          </header>
        </div>
      </Router>
    </DocumentProvider>
  );
}

export default App;